/* eslint-disable max-len, padded-blocks, prefer-destructuring */

export default {
  data() {
    return {
      projectWorkorderLineItemAddModel: null,
      projectWorkorderIncentivePaymentAddModel: null,
      projectWorkorderLineItemDeleteModel: null,
      projectWorkorderLineItemEditModel: null,
      projectWorkOrderLineItemFields: [
        {
          key: 'productName',
          label: 'Cost Item',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: true,
        },
        {
          key: 'quantity',
          label: 'Qty',
          thClass: 'workorder-table-header',
          class: 'text-right number-column',
          sortable: true,
        },
        {
          key: 'productUnit',
          label: 'Units',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: true,
        },
        {
          key: 'salePrice',
          label: 'Unit Cost',
          formatter: (value) => this.$options.filters.toCurrency(value),
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'totalPrice',
          label: 'Item Cost',
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'districtPartnerPercent',
          label: '% District or Partner Cost',
          thClass: 'workorder-table-header',
          class: 'text-right district-partner-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'districtPartnerCost',
          label: 'District or Partner Cost',
          thClass: 'workorder-table-header',
          class: 'text-right district-partner-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'quantityBilledToDate',
          label: 'Qty Bill-to-Date',
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
          sortable: true,
        },
        {
          key: 'costBilledToDate',
          label: 'Cost Bill-to-Date',
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'workOrderLineItemId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const lineItemFundingSource = this.lineItemFundingSourceList.find(
                (e) => e.lineItemId === value,
              );
              if (lineItemFundingSource) {
                return lineItemFundingSource.fundingSourceName;
              }
            }
            return '';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'billingComplete',
          label: 'Billing Complete',
          thClass: 'workorder-table-header',
          class: 'currency-column',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'workorder-table-header',
        },
      ],

      projectWorkOrderIncentivePaymentsFields: [
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: true,
        },
        {
          key: 'paymentAmount',
          label: 'Payment Amount',
          formatter: (value) => this.$options.filters.toCurrency(value),
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'fundingSource',
          label: 'Funding Source',
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: 'incentiveBillingComplete',
          label: 'Billing Complete',
          thClass: 'workorder-table-header',
          class: 'currency-column',
        },
      ],

      projectWorkOrderLineItemItems: [],
      projectWorkOrderLineItemFundingSourceValues: [],
      projectWorkOrderIncentivePaymentValues: [],
    };
  },
  methods: {
    getProjectWorkOrderLineItemFields(workOrder) {
      const projectWorkOrderLineItemFields = [...this.projectWorkOrderLineItemFields];

      if (workOrder.status !== 'Draft') {
        projectWorkOrderLineItemFields.pop();
      }

      return projectWorkOrderLineItemFields;
    },
    getProjectWorkOrderIncentivePaymentFields() {
      const projectWorkOrderIncentivePaymentsFields = [...this.projectWorkOrderIncentivePaymentsFields];
      return projectWorkOrderIncentivePaymentsFields;
    },
    setProjectWorkorderLineItemCalculatedValues(projectWorkorders) {
      projectWorkorders.forEach((projectWorkorder) => {

        projectWorkorder.workOrderLineItems.forEach((workOrderLineItem) => {
          /* eslint-disable-next-line */
          workOrderLineItem.quantityBilledToDate = 0;
        });

        if (projectWorkorder.workOrderLineItems && projectWorkorder.workOrderBills) {
          projectWorkorder.workOrderLineItems.forEach((workOrderLineItem) => {

            const workOrderBills = projectWorkorder.workOrderBills?.filter((e) => e.status !== 'Void');

            const workOrderBillLineItems = workOrderBills.map(
              (e) => e.workOrderBillLineItems,
            ).flat().map(
              (e) => e,
            ).filter(
              (e) => e.workOrderLineItemId === workOrderLineItem.workOrderLineItemId,
            );

            if (workOrderBillLineItems && workOrderBillLineItems.length > 0) {
              const quantityBilledToDate = workOrderBillLineItems.map((e) => e.quantity).reduce((a, b) => a + b).toFixed(2);
              /* eslint-disable-next-line */
              workOrderLineItem.quantityBilledToDate = quantityBilledToDate;
            }

          });
        }
      });
    },
    getProjectWorkOrderLineItemTotal(workorderLineItems) {

      let total = 0;

      if (workorderLineItems.length > 0) {
        total = workorderLineItems.map(
          (e) => Math.round(e.quantity * (e.salePrice * 100)),
        ).reduce(
          (a, b) => a + b,
        );
      }

      /* eslint-disable-next-line */
      total /= Math.pow(10, 2);

      return total;
    },
    getDistrictAndPartnerCost(workorderLineItem) {

      const districtAndPartnerCost = workorderLineItem.quantity * workorderLineItem.salePrice * workorderLineItem.districtAndPartnerCost * 0.01;

      return districtAndPartnerCost;
    },
    getDistrictAndPartnerPercent(workorderLineItem) {

      return workorderLineItem.districtAndPartnerCost;
    },
    async initWorkorderLineItemAddModel(workorder) {
      const fiscalYear = this.getFiscalYear(workorder.requestedDate);
      const opportunityBrief = { ...this.opportunityBriefs.find((e) => e.id === workorder.opportunityId) };
      const totalBudgeted = this.getProjectBudgetSummaryTotalBudget(fiscalYear);
      const totalObligated = this.getAnnualBudgetExpenditureTotalObligated(fiscalYear);

      const loadWorkOrderLineItemFundingSourceValuesResult = this.loadWorkOrderLineItemFundingSourceValues(workorder);
      if (!loadWorkOrderLineItemFundingSourceValuesResult) {
        console.error('Abort initWorkorderLineItemAddModel()');
        return false;
      }

      await this.$store.dispatch('Pricelist/getPricelistEntries', opportunityBrief.pricebookId);

      this.projectWorkorderLineItemAddModel = {
        // Add the 'read-only' properties
        opportunityId: opportunityBrief.id,
        opportunityName: opportunityBrief.name,
        workorderId: workorder.id,
        workorderNumber: workorder.workOrderNumber,
        fiscalYear,
        totalBudgeted,
        totalObligated,
        // Add the editable properties
        fundingSources: this.projectWorkOrderLineItemFundingSourceValues,
        fundingSourceId: null,
        pricebookId: opportunityBrief.pricebookId,
        pricebookEntryId: null,
        quantity: 0,
        unitCost: 0,
        itemCost: 0,
        districtAndPartnerCost: null,
        districtAndPartnerCostValue: null,
      };

      return true;
    },
    async initWorkorderIncentivePaymentAddModel(workorder) {
      const fiscalYear = this.getFiscalYear(workorder.requestedDate);
      const totalBudgeted = this.getProjectBudgetSummaryTotalBudget(fiscalYear);
      const totalObligated = this.getAnnualBudgetExpenditureTotalObligated(fiscalYear);

      const loadWorkOrderIncentivePaymentValuesResult = this.loadWorkOrderIncentivePaymentValues(workorder);
      if (!loadWorkOrderIncentivePaymentValuesResult) {
        console.error('Abort initWorkorderIncentivePaymentAddModel()');
        return false;
      }

      this.projectWorkorderIncentivePaymentAddModel = {
        workorderId: workorder.id,
        workorderNumber: workorder.workOrderNumber,
        fiscalYear,
        totalBudgeted,
        totalObligated,
        incentivePayments: this.projectWorkOrderIncentivePaymentValues,
        incentivePaymentId: null,
        paymentDate: null,
        paymentAmount: null,
      };

      return true;
    },
    async initWorkorderLineItemEditModel(workorderLineItem) {
      const workorder = this.projectWorkorders.find((e) => e.id === workorderLineItem.workOrderId);

      const fiscalYear = this.getFiscalYear(workorder.requestedDate);
      const opportunityBrief = this.opportunityBriefs.find((e) => e.id === workorder.opportunityId);
      const totalBudgeted = this.getProjectBudgetSummaryTotalBudget(fiscalYear);
      const totalObligated = (this.getAnnualBudgetExpenditureTotalObligated(fiscalYear));

      const loadWorkOrderLineItemFundingSourceValuesResult = this.loadWorkOrderLineItemFundingSourceValues(workorder);
      if (!loadWorkOrderLineItemFundingSourceValuesResult) {
        console.error('Abort initWorkorderLineItemEditModel()');
        return false;
      }

      await this.$store.dispatch('Pricelist/getPricelistEntries', opportunityBrief.pricebookId);

      const lineItemFundingSource = this.lineItemFundingSourceList.find(
        (e) => e.lineItemId === workorderLineItem.workOrderLineItemId,
      );

      let itemCost = Math.round(workorderLineItem.quantity * (workorderLineItem.salePrice * 100));

      /* eslint-disable-next-line */
      itemCost /= Math.pow(10, 2);

      this.projectWorkorderLineItemEditModel = {
        // Add the 'read-only' properties
        id: workorderLineItem.workOrderLineItemId,
        opportunityId: opportunityBrief.id,
        workorderId: workorder.id,
        workorderNumber: workorder.workOrderNumber,
        fiscalYear,
        totalBudgeted,
        totalObligated,
        // Add the editable properties
        fundingSources: this.projectWorkOrderLineItemFundingSourceValues,
        fundingSourceId: lineItemFundingSource ? lineItemFundingSource.fundingSourceId : null,
        pricebookId: opportunityBrief.pricebookId,
        pricebookEntryId: workorderLineItem.priceBookEntryId,
        quantity: workorderLineItem.quantity,
        unitCost: workorderLineItem.salePrice,
        itemCost: this.$options.filters.toCurrency(itemCost),
        applyToAll: false,
        billingComplete: workorderLineItem.billingComplete,
        districtAndPartnerCost: workorderLineItem.districtAndPartnerCost,
        districtAndPartnerCostValue: this.getDistrictAndPartnerCost(workorderLineItem),
      };

      return true;
    },
    async loadProjectWorkorderLineItemFundingSources() {
      await this.$store.dispatch('Workorder/setFormLoading', true);

      await this.$store.dispatch(
        'Project/fetchProjectBudget',
        parseInt(this.$route.params.id, 10),
      );

      if (this.projectWorkorders) {
        await this.$store.dispatch(
          'Project/getProjectWorkorderLineItemFundingSources',
          this.projectWorkorders.map((e) => e.id),
        );
      }

      this.lineItemFundingSourceList = [];

      this.projectWorkorderLineItemFundingSources.forEach((e) => {
        const lineItemFundingSource = this.fundingSources.find(
          (fundingSource) => fundingSource.recorD_ID === e.fundingSourceId,
        );
        if (lineItemFundingSource) {
          this.lineItemFundingSourceList.push({
            lineItemId: e.workOrderLineItemId,
            fundingSourceId: lineItemFundingSource.recorD_ID,
            fundingSourceName: lineItemFundingSource.recorD_NAME,
          });
        }
      });

      await this.$store.dispatch('Workorder/setFormLoading', false);
    },
    loadWorkOrderLineItemFundingSourceValues(workOrder) {
      const fiscalYear = this.getFiscalYear(workOrder.requestedDate);

      const projectBudgetYear = this.projectBudget.projectBudgetYears.find(
        (e) => e.year === fiscalYear,
      );

      if (!projectBudgetYear) {
        console.error('Invalid object reference: projectBudgetYear');
        this.showErrorMessageAlert = true;
        this.showErrorMessageAlertBody = `ERROR! The Annual Budget for FY ${fiscalYear} could not be found!  Please check your work order's Requested Completion Date (${workOrder.requestedDate})`;
        console.error('Abort loadWorkOrderLineItemFundingSourceValues()');
        return false;
      }

      const fundingSourceIds = projectBudgetYear.projectBudgetLineItems.map(
        (e) => e.fundingSourceId,
      ).sort(
        (a, b) => a - b,
      );

      let annualBudgetIncreaseFundingSourceIds = [];
      if (projectBudgetYear.annualBudgetIncreases) {
        annualBudgetIncreaseFundingSourceIds = projectBudgetYear.annualBudgetIncreases.map((e) => e.fundingSourceId);
      }

      let projectWorkOrderLineItemFundingSourceValues = this.fundingSources.map((e) => {
        const qbAccount = e.customfields.filter((customfield) => customfield.fielD_NAME === 'Account__c')[0];
        const projectFundingSource = {
          id: e.recorD_ID,
          name: e.recorD_NAME,
          source: qbAccount.fielD_VALUE,
        };
        return projectFundingSource;
      });

      /* eslint-disable-next-line max-len */
      projectWorkOrderLineItemFundingSourceValues = projectWorkOrderLineItemFundingSourceValues.filter(
        (e) => fundingSourceIds.includes(e.id) || annualBudgetIncreaseFundingSourceIds.includes(e.id),
      );

      /* eslint-disable-next-line max-len */
      this.projectWorkOrderLineItemFundingSourceValues = projectWorkOrderLineItemFundingSourceValues.sort(
        (a, b) => a.name.localeCompare(b.name),
      );

      return true;
    },
    loadWorkOrderIncentivePaymentValues(workOrder) {
      const fiscalYear = this.getFiscalYear(workOrder.requestedDate);

      const projectBudgetYear = this.projectBudget.projectBudgetYears.find(
        (e) => e.year === fiscalYear,
      );

      if (!projectBudgetYear) {
        console.error('Invalid object reference: projectBudgetYear');
        this.showErrorMessageAlert = true;
        this.showErrorMessageAlertBody = `ERROR! The Annual Budget for FY ${fiscalYear} could not be found!  Please check your work order's Requested Completion Date (${workOrder.requestedDate})`;
        console.error('Abort loadWorkOrderIncentivePaymentValues()');
        return false;
      }

      const nonCancelledCompletedWorkOrderIncentives = this.projectWorkorders
        .filter((wo) => wo.status !== 'Cancelled' && wo.status !== 'Completed').map(
          (e) => e.workOrderProjectIncentives,
        ).flat();

      const completedWorkOrderIncentives = this.projectWorkorders
        .filter((wo) => wo.status === 'Completed').map(
          (e) => e.workOrderProjectIncentives,
        ).flat();

      const billedCompletedWorkOrderIncentives = completedWorkOrderIncentives.filter((ip) => ip.paymentDate != null);
      const existingWorkOrderIncentives = [...new Set([...billedCompletedWorkOrderIncentives, ...nonCancelledCompletedWorkOrderIncentives])];

      const incentivesInFiscalYear = this.projectIncentivePayments
        .filter((ip) => this.getFiscalYear(ip.dateDue) === fiscalYear)
        .filter((ip) => existingWorkOrderIncentives.filter((wopi) => wopi.projectIncentivePaymentId === ip.id).length === 0);

      this.projectWorkOrderIncentivePaymentValues = incentivesInFiscalYear.map(
        (ip) => (
          {
            name: ip?.incentiveType?.name?.concat(', ')?.concat(this.$options.filters.toCurrency(ip?.amountPaid)?.concat(', ')?.concat(this.fundingSources.find((fundingSource) => fundingSource.recorD_ID === ip?.fundingSourceId).recorD_NAME)),
            id: ip?.id,
            value: ip,
          }),
      );

      return true;
    },
    onWorkorderLineItemAddClick(workorder) {
      (async () => {
        await this.$store.dispatch('Workorder/setFormLoading', true);

        const initWorkorderLineItemAddModelResult = await this.initWorkorderLineItemAddModel(workorder);

        if (!initWorkorderLineItemAddModelResult) {
          await this.$store.dispatch('Workorder/setFormLoading', false);
          return;
        }

        this.projectWorkorderLineItemAddIsVisible = false;

        this.$store.dispatch('Workorder/setWorkorderLineItemAddModel', this.projectWorkorderLineItemAddModel).then(() => {
          this.projectWorkorderLineItemAddIsVisible = true;
        });

        await this.$store.dispatch('Workorder/setFormLoading', false);
      })();
    },
    onWorkorderIncentivePaymentAddClick(workorder) {
      (async () => {
        await this.$store.dispatch('Workorder/setFormLoading', true);

        const initWorkorderIncentivePaymentAddModelResult = await this.initWorkorderIncentivePaymentAddModel(workorder);

        if (!initWorkorderIncentivePaymentAddModelResult) {
          await this.$store.dispatch('Workorder/setFormLoading', false);
          return;
        }

        this.projectWorkorderIncentivePaymentAddIsVisible = false;

        this.$store.dispatch('Workorder/setWorkorderIncentivePaymentAddModel', this.projectWorkorderIncentivePaymentAddModel).then(() => {
          this.projectWorkorderIncentivePaymentAddIsVisible = true;
        });

        await this.$store.dispatch('Workorder/setFormLoading', false);
      })();
    },
    async onWorkOrderIncentivePaymentBillingCompleteChanged(event, projectWorkorder, item) {
      const model = {
        workOrderIncentivePaymentId: item.id,
        projectIncentivePaymentId: item.projectIncentivePaymentId,
        billingComplete: event,
      };

      (async () => {
        try {
          this.workOrderIncentivePaymentsCompleteSaving = true;
          await this.$store.dispatch(
            'Workorder/setWorkorderIncentivePaymentBillingComplete',
            model,
          );

          await this.$store.dispatch(
            'Project/getProjectIncentivePayments',
            this.project.id,
          );

          projectWorkorder.workOrderProjectIncentives.forEach((inc) => {
            if (inc.id === item.id) {
              /* eslint-disable-next-line no-param-reassign */
              inc.paymentDate = event === true ? new Date() : null;
            }
          });

          this.workOrderIncentivePaymentsCompleteSaving = false;
        } catch (exception) {
          console.error('Exception caught calling this.$store.dispatch(\'Workorder/setWorkorderIncentivePaymentBillingComplete\')');
          console.error('exception: ', exception);
        }
      })();
    },
    async onWorkOrderLineItemBillingCompleteChanged(event, projectWorkorder, item) {
      const model = {
        workOrderId: item.workOrderId,
        workOrderLineItemId: item.workOrderLineItemId,
        billingComplete: event,
      };

      (async () => {
        try {
          this.workOrderLineItemBillingCompleteSaving = true;
          await this.$store.dispatch(
            'Workorder/setWorkorderLineItemBillingComplete',
            model,
          );
          this.workOrderLineItemBillingCompleteSaving = false;
        } catch (exception) {
          console.error('Exception caught calling this.$store.dispatch(\'Workorder/setWorkorderLineItemBillingComplete\')');
          console.error('exception: ', exception);
        }
      })();
    },
    onWorkOrderLineItemEditClick(workorderLineItem) {
      (async () => {
        await this.$store.dispatch('Workorder/setFormLoading', true);

        await this.initWorkorderLineItemEditModel(workorderLineItem);

        this.projectWorkorderLineItemEditIsVisible = false;

        const originalItemCost = Math.round(this.projectWorkorderLineItemEditModel.quantity * (this.projectWorkorderLineItemEditModel.unitCost * 100));
        const originalDistrictPartnerCost = originalItemCost * (this.projectWorkorderLineItemEditModel.districtAndPartnerCost * 0.01);
        this.projectWorkorderLineItemEditModel.originalDistrictPartnerCost = originalDistrictPartnerCost;

        this.$store.dispatch('Workorder/setWorkorderLineItemEditModel', this.projectWorkorderLineItemEditModel).then(() => {
          this.projectWorkorderLineItemEditIsVisible = true;
        });

        await this.$store.dispatch('Workorder/setFormLoading', false);
      })();
    },
    onProjectWorkOrderLineItemEditCancelClick() {
      this.$bvModal.hide(this.projectWorkOrderLineItemEditModalId);
    },
    onValidated(isValid, errors) {
      this.formValid = isValid;
      this.validateRequiredFields(errors || []);
    },
    onWorkOrderLineItemDeleteClick(workorderLineItem) {
      this.projectWorkorderLineItemDeleteModel = { ...workorderLineItem };
    },
    async onWorkOrderLineItemDeleteOkClick() {
      await this.$store.dispatch('Workorder/setFormLoading', true);
      await this.$store.dispatch(
        'Workorder/deleteWorkorderLineItem',
        this.projectWorkorderLineItemDeleteModel,
      );
      await this.$store.dispatch('Workorder/setFormLoading', false);
      const workorder = this.projectWorkorders.find(
        (e) => e.id === this.projectWorkorderLineItemDeleteModel.workOrderId,
      );
      const workorderLineItem = workorder.workOrderLineItems.find(
        (e) => e.workOrderLineItemId === this.projectWorkorderLineItemDeleteModel.workOrderLineItemId,
      );
      workorder.workOrderLineItems.splice(
        workorder.workOrderLineItems.indexOf(workorderLineItem),
        1,
      );
    },
    validateRequiredFields(errors) {
      this.formValid = true;
      /* eslint-disable-next-line max-len */
      if (!this.projectWorkorderLineItemEditModel.fundingSourceId) this.formValid = false;
      if (errors && errors.length > 0) this.formValid = false;
    },
  },
};
